import { createShallowEqualSelector, getSettingValueSelector, TargetSelector } from "@client/selectors";
import * as React from "react";

export const makeStyleSelector = () => {
  const spacerHeightSelector = getSettingValueSelector(TargetSelector.Entity, "spacerHeight");

  return createShallowEqualSelector(
    [spacerHeightSelector],
    (height): React.CSSProperties => ({
      height
    })
  );
};
